/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getMission = createAsyncThunk(
  'AboutToPlay/getMission',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/ludo/team_activity_mission', {
      ...store.getState().env.deviceinfo,
      ...p,
      page_size: 50,
    })
    return resp.data
  }
)

export const getReward = createAsyncThunk(
  'AboutToPlay/getReward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/gamestore/ludo/team_activity_mission_reward',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38796634
export const getMyRank = createAsyncThunk(
  'AboutToPlay/getMyRank',
  async (p: any, store: any) => {
    const resp = await http.post('/gamestore/ludo/team_activity_rank', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export enum missionStatus {
  goToDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardType {
  goldCoin = 1,
  silverCoin = 7,
}
interface IMission {
  mission_id: number
  reward: any
  status: number
  current: number
  target: number
  desc: string
}
interface Mission {
  canGetReward: boolean
  err_msg: string
  activity_time: string // 积分值
  list: Array<IMission>
}
interface IRank {
  rank: number
  name: string
  avatar: string
  rounds: number
  mine?: boolean
  mid: number
}
interface IReward {
  cnt: any
  describe: number
  url: number
}

const initialState: {
  mission: Mission
  myRank: {
    err_msg: string
    my_rank_info: IRank
    button_state: 0 | 1 | 2
    rewards: Array<any>
  }
} = {
  mission: {
    err_msg: '',
    activity_time: '',
    canGetReward: false,
    list: [],
  },
  myRank: {
    err_msg: '',
    my_rank_info: {
      avatar:
        'http://me-media-gateway.srv.test.ixiaochuan.cn/img/png/id/4302911',
      name: '',
      rank: 0,
      rounds: 0,
      mine: true,
      mid: 0,
    },
    button_state: 0,
    rewards: [],
  },
}

const getRewardStatus = (data) =>
  data?.list?.findIndex((item) => item.status === missionStatus.canGet) >= 0

export const AboutToPlaySlice = createSlice({
  name: 'AboutToPlay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMission.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.mission, {
          ...data,
          canGetReward: getRewardStatus(data),
        })
      })
      .addCase(getReward.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.mission, {
          ...data,
          canGetReward: getRewardStatus(data),
        })
      })
      .addCase(getMyRank.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state.myRank, data)
      })
  },
})

export default AboutToPlaySlice.reducer
